var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24023 7.8623C5.24023 7.16741 5.51628 6.50097 6.00765 6.0096C6.49902 5.51823 7.16545 5.24219 7.86035 5.24219H11.3538C12.0487 5.24219 12.7152 5.51823 13.2065 6.0096C13.6979 6.50097 13.974 7.16741 13.974 7.8623V11.3558C13.974 12.0507 13.6979 12.7171 13.2065 13.2085C12.7152 13.6999 12.0487 13.9759 11.3538 13.9759H7.86035C7.16545 13.9759 6.49902 13.6999 6.00765 13.2085C5.51628 12.7171 5.24023 12.0507 5.24023 11.3558V7.8623ZM5.24023 30.57C5.24023 29.8751 5.51628 29.2087 6.00765 28.7173C6.49902 28.2259 7.16545 27.9499 7.86035 27.9499H11.3538C12.0487 27.9499 12.7152 28.2259 13.2065 28.7173C13.6979 29.2087 13.974 29.8751 13.974 30.57V34.0635C13.974 34.7584 13.6979 35.4248 13.2065 35.9162C12.7152 36.4075 12.0487 36.6836 11.3538 36.6836H7.86035C7.16545 36.6836 6.49902 36.4075 6.00765 35.9162C5.51628 35.4248 5.24023 34.7584 5.24023 34.0635V30.57Z",
    stroke: "#007AFF",
    strokeWidth: 2.62012
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9754 32.321H36.6831M27.9494 9.61328H13.9754M28.5153 13.4142L13.3623 28.5672",
    stroke: "#007AFF",
    strokeWidth: 2.62012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9463 7.8623C27.9463 7.16741 28.2223 6.50097 28.7137 6.0096C29.2051 5.51823 29.8715 5.24219 30.5664 5.24219H34.0599C34.7548 5.24219 35.4212 5.51823 35.9126 6.0096C36.404 6.50097 36.68 7.16741 36.68 7.8623V11.3558C36.68 12.0507 36.404 12.7171 35.9126 13.2085C35.4212 13.6999 34.7548 13.9759 34.0599 13.9759H30.5664C29.8715 13.9759 29.2051 13.6999 28.7137 13.2085C28.2223 12.7171 27.9463 12.0507 27.9463 11.3558V7.8623Z",
    stroke: "#007AFF",
    strokeWidth: 2.62012
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4414 36.6868L33.8659 35.0344C35.7436 33.7523 36.6816 33.1148 36.6816 32.32C36.6816 31.5252 35.7436 30.8859 33.8659 29.6055L31.4414 27.9531",
    stroke: "#007AFF",
    strokeWidth: 2.62012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW7);
export default __webpack_public_path__ + "static/media/w7.d9711eccf7cb3852dddfeaaeed60c4ca.svg";
export { ForwardRef as ReactComponent };